import http from 'axios'
import { root } from './conf'

const kwanza = () => {
  return http.get(`${root.replace(/\/v[0-9]+/, '')}/about`).then(res => {
    return res.data
  })
}

const self = {
  kwanza
}

export default self
